module.exports = __webpack_public_path__ + "images/category_lp/trading_card/store_images/5@2x_95a6a8e57b7dff56d7722481715baa5d.png";